import React from 'react';
import { useAuthStore } from '../../stores/useAuthStore';
import { useModalStore } from '../../stores/useUIStore';
import AgoraBirdIcon from '../common/AgoraBirdIcon';

/**
 * 🔐 Componente de bloqueo de contenido premium
 * Muestra blur + botón de suscripción si el usuario no tiene pase activo
 */
const PremiumContentBlocker = ({ post, isBlocked }) => {
  const openModal = useModalStore((state) => state.openModal);
  const hasPassFor = useAuthStore((state) => state.hasPassFor);

  if (!isBlocked) {
    return null;
  }

  const creatorId = post.author?._id;
  const isPassed = hasPassFor(creatorId);

  if (isPassed) {
    return null; // Usuario tiene pase, mostrar contenido normal
  }

  const handleSubscribeClick = () => {
    openModal('buyPass', { blogger: post.author });
  };

  return (
    <div className="relative bg-gradient-to-b from-transparent via-transparent to-gray-900 rounded-lg overflow-hidden h-48 flex flex-col items-center justify-center backdrop-blur-sm">
      {/* Blur de fondo */}
      <div className="absolute inset-0 bg-black bg-opacity-40 backdrop-blur-md"></div>

      {/* Contenido del blocker */}
      <div className="relative z-10 flex flex-col items-center justify-center h-full space-y-4">
        <div className="text-center">
          <div className="mb-3">
            <AgoraBirdIcon className="w-12 h-12 text-blue-500 mx-auto" />
          </div>
          <p className="text-white font-semibold text-lg mb-2">Contenido Exclusivo</p>
          <p className="text-gray-200 text-sm">
            Solo accesible para suscriptores de {post.author?.username}
          </p>
        </div>

        {/* Botón de suscripción */}
        <button
          onClick={handleSubscribeClick}
          className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-6 rounded-lg transition-colors duration-200 flex items-center space-x-2"
        >
          <AgoraBirdIcon className="w-4 h-4" />
          <span>Suscribirse</span>
        </button>

        <p className="text-gray-300 text-xs">
          Obtén acceso ilimitado a todo su contenido
        </p>
      </div>
    </div>
  );
};

export default PremiumContentBlocker;
